import axiosIns from '@/libs/axios'
import {getUserData} from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStoreGallery(ctx , store_id) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/store_gallery', {params:store_id})
          .then(response => {
            if (response.data.store_gallery) {
              resolve(response)
            } else {
              reject(new Error('没有找到数据'))
            }
          })
          .catch(error => reject(error))
      })
    },

    updateStoreGallery(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.post('/store_gallery', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },

    // 上传图片
    uploadGalleryImage(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.post('/store_gallery/images', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },

    // 获取图片列表
    fetchGalleryImages(ctx, store_id) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/store_gallery/images', {params:store_id})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // 删除图片
    deleteGalleryImage(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns.delete(`/store_gallery/images/${params.imageId}?store_id=${params.store_id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
  }
}
